import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Typography,
  Box,
  Card,
  CardContent,
  Grid,
  Divider,
} from "@mui/material";
import GavelIcon from "@mui/icons-material/Gavel";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PersonIcon from "@mui/icons-material/Person";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import api from "../../api";

const DetalleInfraccion = ({ selectedInfraccion, handleDetailClose }) => {
  const [infraccion, setInfraccion] = useState(null);

  useEffect(() => {
    if (selectedInfraccion) {
      api
        .get(`infracciones/${selectedInfraccion.id}/`)
        .then((response) => setInfraccion(response.data))
        .catch(() => alert("Error al cargar detalles de la infracción."));
    } else {
      setInfraccion(null);
    }
  }, [selectedInfraccion]);

  return (
    <Dialog open={!!selectedInfraccion} onClose={handleDetailClose} fullWidth maxWidth="md">
      <DialogContent dividers sx={{ padding: "20px", backgroundColor: "#f4f6f9" }}>
        {infraccion ? (
          <Card sx={{ boxShadow: 3, borderRadius: "8px", padding: 2 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#152d51",
                display: "flex",
                alignItems: "center",
                marginBottom: 2,
              }}
            >
              <GavelIcon sx={{ marginRight: 1, color: "#152d51" }} />
              <strong>Detalles de la Infracción</strong>
            </Typography>

            <Divider sx={{ my: 2 }} />
            <CardContent>
              <Grid container spacing={2}>
                {/* Left Column */}
                <Grid item xs={12} sm={6}>
                  <InfoItem icon={<GavelIcon />} label="Código de Infracción" value={infraccion.codigo_multa} />
                  <InfoItem icon={<GavelIcon />} label="Lugar de Radicación" value={infraccion.lugar_radicacion} />
                  <InfoItem icon={<CalendarTodayIcon />} label="Fecha" value={infraccion.fecha} />
                  <InfoItem icon={<AttachMoneyIcon />} label="Monto" value={`$${infraccion.monto} ARS`} />
                  <InfoItem
                    icon={infraccion.pagada ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
                    label="¿Pagada?"
                    value={infraccion.pagada ? "Sí" : "No"}
                  />
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} sm={6}>
                  <InfoItem
                    icon={<DirectionsCarIcon />}
                    label="Vehículo"
                    value={infraccion.vehiculo_nombre || "No asignado"}
                  />
                  <InfoItem
                    icon={<PersonIcon />}
                    label="Conductor Responsable"
                    value={infraccion.conductor ? `${infraccion.conductor.nombre} ${infraccion.conductor.apellido}` : "No asignado"}
                  />
                  <InfoItem icon={<GavelIcon />} label="Descripción" value={infraccion.descripcion} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No se encontraron detalles de la infracción.
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ padding: "16px", backgroundColor: "#f4f6f9" }}>
        <Button onClick={handleDetailClose} variant="contained" sx={{ backgroundColor: "#152d51" }} fullWidth>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const InfoItem = ({ icon, label, value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      marginBottom: 1,
      backgroundColor: "#f4f6f9",
      padding: 1.5,
      borderRadius: "8px",
    }}
  >
    {icon && <Box sx={{ marginRight: 1, color: "#152d51" }}>{icon}</Box>}
    <Typography variant="subtitle1">
      <strong>{label}:</strong> {value}
    </Typography>
  </Box>
);

export default DetalleInfraccion;
